import React from "react";
import GameBoard from "./components/GameBoard";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>🧠 Memory Madness</h1>
      <GameBoard />
    </div>
  );
}

export default App;
